import { PathMarker } from './path-marker';
import { PathPointMat } from '../path-point/path-point-mat';

export class PathMarkerMat extends PathMarker {
  public override pathPoint: PathPointMat;
}
